export type RitualType = "IN_PERSON" | "VIRTUAL_COURSE" | "SELF_GUIDED" | "SELF_GUIDED_COURSE"

export interface ExploreRitual {
  id: string
  title: string
  ritualType: RitualType
  isPaid: boolean
  isDonationBased?: boolean
  fee: number | null
  duration: string | null
  city: string | null
  state: string | null
  ritualTs: string | null
  hasMeetingLink: boolean
  meetingLink: string | null
  coverImage: string | null
  user: {
    id: string
    username: string
    name: string
    profilePictureUrl: string | null
  } | null
  isSaved: boolean
}

export interface ExploreRitualsResponse {
  rituals: ExploreRitual[]
  total: number
  page: number
  totalPages: number
  hasMore: boolean
}

export interface ExploreRitualsFilters {
  search?: string
  sort?: "newest" | "trending" | "relevance"
  price?: "free" | "paid"
  priceRange?: [number, number]
  format?: RitualType
  duration?: "short" | "medium" | "long"
  intention?: string
  intentions?: string
  traditions?: string
  city?: string
  state?: string
  country?: string
}

export const RITUAL_FORMAT_LABELS = {
  IN_PERSON: "In-Person",
  VIRTUAL_COURSE: "Live Virtual",
  SELF_GUIDED: "Self-Guided",
  SELF_GUIDED_COURSE: "Self-Guided Course",
} as const satisfies Record<RitualType, string>
